<div class="overlay">
  <div class="loader-box">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    @if (templateMessage) {
      <p *ngIf="templateMessage">{{ templateMessage }}</p>
    }
  </div>
</div>
